/**
 * Fehler-Marker für das Verknüpfen eines Buchers mit einem bestehenden Login
 * (docs/plans/2026-09-16-bucher-mitarbeiter-konto-verknuepfen.md, E4/E5).
 *
 * Der Vertrag zwischen Server und Admin-Client läuft per Text-Marker in der
 * Fehlermeldung (wie `[duplicate]user.email`), nicht per `extensions.code`: die
 * Bucher-Resolver wickeln jeden Fehler in `BadRequestError(`… ${error}`)`, nur der
 * Substring kommt beim Client an. Server und Client importieren dieselben Strings.
 */

/** Zielkonto ist ein Mitarbeiter-Login: erneut senden mit `linkExistingAccountConfirmed: true`. */
export const LINK_CONFIRMATION_REQUIRED = "[linkAccount]confirmationRequired";

/** Ein anderer Bucher ist bereits mit dem Zielkonto verknüpft; die Bucher-ID hängt mit `:` an. */
export const LINK_ACCOUNT_ALREADY_LINKED = "[linkAccount]accountAlreadyLinked";

/** Das Zielkonto ist höher eingestuft als der Aufrufer (nie nach oben verknüpfen). */
export const LINK_RANK_TOO_HIGH = "[linkAccount]rankTooHigh";

/** Verknüpfen mit einem Mitarbeiter-Login erst ab Rolle Admin. */
export const LINK_FORBIDDEN = "[linkAccount]forbidden";
